// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"17":"66265cc4","623":"cf14142f"}[chunkId] + ".chunk.css";
};